import { render, staticRenderFns } from "./channel-options.vue?vue&type=template&id=21f6c636&scoped=true"
import script from "./channel-options.vue?vue&type=script&setup=true&lang=js"
export * from "./channel-options.vue?vue&type=script&setup=true&lang=js"
import style0 from "./channel-options.vue?vue&type=style&index=0&id=21f6c636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6c636",
  null
  
)

export default component.exports